var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareoffShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 75,
    viewBox: "0 0 95 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.88 4.5C41.89 17.46 41.9 30.41 41.91 43.37C41.93 43.43 41.94 43.49 41.96 43.55C42.22 44.57 42.34 45.92 41.91 47.6C57.75 55.01 73.59 62.42 89.43 69.82C89.66 69.95 89.95 69.78 89.95 69.51V12.27C89.95 11.99 89.64 11.82 89.4 11.98L5.05 68.09C4.82 68.25 4.5 68.08 4.5 67.8V13.75C4.5 13.47 4.82 13.3 5.05 13.46C10.92 17.49 16.79 21.52 22.65 25.55",
    stroke: "white",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareoffShortLogo);
export default __webpack_public_path__ + "static/media/careoff-short-logo.8f20c4e3b43b0b3d9621c830437ae4af.svg";
export { ForwardRef as ReactComponent };